module.exports = __webpack_public_path__ + "static/media/cash-for-cars-beenleigh.b7b8a80a.jpg";